import logo from './logo.svg';
import './App.css';
import Post from './components/Postpage/Post';

function App() {
  return (
    <div className="App">
      <Post/>
    </div>
  );
}

export default App;
